import React from "react";
import { useLanguage } from "../LanguageContext";

const AboutSulution = () => {
  const { language } = useLanguage();

  return (
    <div className="hardware-container">
      <div className="content">
        <h2 className="heading">
          <span>Our Solutions</span>
        </h2>
        <p className="description">
          {language === "en" ? (
            <>
              At Proscope, we deliver end-to-end IT solutions designed to solve
              complex business challenges and support long-term growth. As a
              system integrator with over a decade of experience, we combine
              technology, strategy, and expertise to create environments that
              are secure, scalable, and aligned with your operations.
              <br />
              <br />
            </>
          ) : (
            <>
              ที่ Proscope เรานำเสนอโซลูชันด้านไอทีแบบครบวงจร
              เพื่อช่วยให้องค์กรแก้ไขปัญหาที่ซับซ้อน
              พร้อมรองรับการเติบโตในระยะยาว เราผสมผสานเทคโนโลยี กลยุทธ์
              และความเชี่ยวชาญเข้าด้วยกัน เพื่อสร้างระบบที่มีความปลอดภัย
              ยืดหยุ่น และสอดคล้องกับการดำเนินงานของคุณ
              <br />
              <br />
            </>
          )}
        </p>

        {language === "en" ? (
          <>
            <p className="description">
              Our team works closely with each client to understand their unique
              goals and tailor solutions that integrate seamlessly into their
              ecosystem— whether on-premise, in the cloud, or hybrid. We focus
              not just on implementation, but also on building long-term
              reliability through consulting, knowledge transfer, and responsive
              support.
            <br />
            <br />
            </p>
            <p className="description">
              Every solution is backed by certified engineers and guided by best
              practices to ensure performance and peace of mind.
            </p>
          </>
        ) : (
          <>
            <p className="description">
              ทีมงานของเราทำงานใกล้ชิดกับลูกค้าในทุกขั้นตอน
              เพื่อออกแบบโซลูชันที่เหมาะสมกับโครงสร้างระบบที่มีอยู่
              ไม่ว่าจะเป็นระบบภายใน ออนคลาวด์ หรือแบบไฮบริด
              เราให้ความสำคัญกับการวางแผน การติดตั้ง การส่งมอบความรู้
              และบริการหลังการขาย เพื่อความมั่นใจในระยะยาว
              <br />
              <br />
            </p>
            <p className="description">
              ทุกโซลูชันของเราได้รับการดูแลโดยวิศวกรที่ผ่านการรับรอง
              พร้อมแนวทางที่ยึดตามมาตรฐานสากล
              หากคุณกำลังมองหาโซลูชันที่ช่วยขับเคลื่อนองค์กร เราพร้อมให้คำปรึกษา
            </p>
          </>
        )}

        <div className="horizontal-text-container">
          <p>Solution</p>
          <p>/</p>
          <p>All Portfolio</p>
        </div>
      </div>
    </div>
  );
};

export default AboutSulution;
